
export class BoastGuiFeiInfo {
    /** 提问 */
    quiz: string;
    select: string[][];
    /** 正确 */
    correct: string;
    /** 错误 */
    incorrect: string;
    /** 正确答案 */
    correctAnswer: number[];
}

export const BoastGuiFeiConfig: BoastGuiFeiInfo[] = [
    {
        quiz: '我今天美吗？',
        select: [[
            "属于是",
            "可能是",
            "莫非是",
        ],
        [
            "乌龟办走读",
            "麻雀吃草莓",
            "老奶奶进被窝",
            "神仙放屁",
            "水仙不开花",
        ],
        [
            "鳖不住了",
            "雀食莓",
            "给爷整笑了",
            "不同凡响",
            "装蒜",
        ]],
        correct: '年纪轻轻嘴倒挺甜',
        incorrect: '你什么意思？',
        correctAnswer: [0, 1, 1],
    }, 
    {
        quiz: '现在京城房价低，本宫趁机又买了一套宅子',
        select: [[
            "就好比",
            "应该是",
            "反正不是",
        ],
        [
            "肚脐眼放屁",
            "飞上天点灯",
            "盲人做拉面",
            "麻雀啄牛腚",
            "小刀扎屁股",
        ],
        [
            "你怎么响的",
            "高明啊",
            "瞎扯",
            "雀食牛逼",
            "开眼了",
        ]],
        correct: '你说话还挺有趣',
        incorrect: '我看你是活腻了',
        correctAnswer: [0, 1, 1],
    }, 
    {
        quiz: '你觉得十年后我还会像现在这样漂亮吗？',
        select: [[
            "必须是",
            "大概是",
            "难道是",
        ],
        [
            "裤裆着火",
            "茅厕里跳高",
            "屁股上放暖水瓶",
            "八二年龙井",
            "布袋里失火",
        ],
        [
            "裆燃了",
            "过粪了",
            "有一腚的水瓶",
            "老绿茶了",
            "烧包",
        ]],
        correct: '借你吉言',
        incorrect: '赶紧给本宫闭嘴',
        correctAnswer: [0, 0, 0],
    }, 
    {
        quiz: '我是不是全天下最美的女人？',
        select: [[
            "肯定是",
            "或许是",
            "也许是",
        ],
        [
            "老母鸡上房顶",
            "被窝里晒太阳",
            "癞蛤蟆找青蛙",
            "屎壳郎戴面具",
            "木棍忤青蛙",
        ],
        [
            "你算个什么鸟",
            "窝日",
            "长得丑玩得花",
            "臭不要脸",
            "顶呱呱",
        ]],
        correct: '说的我都不好意思了',
        incorrect: '本宫要治你的罪',
        correctAnswer: [0, 4, 4],
    }, 
    {
        quiz: '有传言说新来的妃子比本宫还好看',
        select:[[
            "那是其它人",
            "这都是",
            "必须是",
        ],
        [
            "光腚看天",
            "太监开会",
            "陈年水龙头",
            "和尚的房子",
            "老太涂胭脂",
        ],
        [
            "有眼无珠",
            "无稽之谈",
            "真的锈",
            "庙啊",
            "给点颜色瞧瞧",
        ]],
        correct: '还是你有眼光',
        incorrect: '你会不会说话？',
        correctAnswer: [0, 1, 1],
    }, 

]